import axios from 'axios'
import store from '@/store/'
import qs from 'qs'

axios.interceptors.request.use(
  function(config) {
    config.headers['Authorization'] = window.localStorage.getItem('token')
    if (window.localStorage.getItem('lang')) {
      config.headers['Accept-Language'] = window.localStorage.getItem('lang')
    }
    config.paramsSerializer = params => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    let errorResponse = error.response
    const forbidden = [403, 401].includes(errorResponse.status)
    if (forbidden) {
      window.localStorage.removeItem('token')
      store.commit('clearUserInfo')
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

export function prepareURL(url, urlParams) {
  urlParams = urlParams || {}
  if (typeof urlParams !== 'object') {
    urlParams = {
      id: urlParams
    }
  }

  const convertURLFragment = fragment =>
    fragment.startsWith(':') ? urlParams[fragment.slice(1)] : fragment
  return url
    .split('/')
    .map(convertURLFragment)
    .join('/')
    .replace('//', '/')
}

export default function(url) {
  return {
    fetch: (urlParams, payload) => {
      return axios.get(prepareURL(url, urlParams), payload)
    },
    all: (payload = {}) => {
      const params = {
        page_size: 'max',
        ...payload
      }
      return axios.get(prepareURL(url), { params })
    },
    update: (urlParams, payload, headers = {}) => {
      return axios.put(prepareURL(url, urlParams), payload, { headers })
    },
    patch: (urlParams, payload, headers = {}) => {
      return axios.patch(prepareURL(url, urlParams), payload, { headers })
    },
    get: (urlParams, payload) => {
      return axios.get(prepareURL(url, urlParams), payload)
    },
    save: (payload, headers = {}) => {
      return axios.post(prepareURL(url), payload, headers)
    },
    delete: urlParams => {
      return axios.delete(prepareURL(url, urlParams))
    }
  }
}
